import React, { useState, useEffect } from 'react';
import Chip from '@material-ui/core/Chip';
import map from 'lodash/map';
import filter from 'lodash/filter';
import includes from 'lodash/includes';
import PropTypes from 'prop-types';
import size from 'lodash/size';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
const propTypes = {
  collection: PropTypes.array.isRequired,
  selectedIds: PropTypes.array.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  fieldName: PropTypes.string.isRequired,
};

const defaultProps = {
  collection: [],
  selectedIds: [],
  setFieldValue: () => {
  },
  fieldName: '',
};

function ChipCategoryClosed({
  collection,
  selectedIds,
  setFieldValue,
}) {

  const selectedOptions = filter(collection, (option) => includes(selectedIds, option.id));
  const [changedOptions, setChangedIds] = useState(selectedOptions);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(!Boolean(size(collection)));
    const selectedOptions = filter(collection, (option) => includes(selectedIds, option.id));
    setChangedIds(selectedOptions);
  }, [collection, selectedIds]);

  if (loading) return (<p>...</p>);
  if (!size(changedOptions)) return (<p>...</p>);
  return map(changedOptions, (option, index) => (
    <Chip
      color="primary"
      key={index}
      size="small"
      label={`${option.name}(${option.count})`}
      onClick={()=>setFieldValue(option.id)}
      icon={<AddCircleOutlineIcon />}
      style={{marginLeft:'5px'}}
    />
  ));
}

ChipCategoryClosed.propTypes = propTypes;
ChipCategoryClosed.defaultProps = defaultProps;

export default ChipCategoryClosed;




// WEBPACK FOOTER //
// ./src/components/ChipCategoryClosed/index.jsx